
import React, { useEffect, useState, useCallback, useMemo } from "react";

const AdminDashboard = () => {
  const [password, setPassword] = useState("");
  const [authenticated, setAuthenticated] = useState(false);

  const [orders, setOrders] = useState([]);
  const [inventory, setInventory] = useState([]);
  const [search, setSearch] = useState("");
  const [editingInventory, setEditingInventory] = useState(false);
  const [originalInventory, setOriginalInventory] = useState([]);

  // New item form state
  const [newItem, setNewItem] = useState({
    product: "",
    size: "",
    stock: 0
  });
  const [showAddForm, setShowAddForm] = useState(false);

  // Initial inventory data (combining your original inventory with size chart data)
  const initialInventoryData = useMemo(() => [
    { product: "White Go Runners", size: "35", stock: 2 },
    { product: "White Go Runners", size: "36", stock: 2 },
    { product: "White Go Runners", size: "37", stock: 2 },
    { product: "White Go Runners", size: "38", stock: 2 },
    { product: "White Go Runners", size: "39", stock: 2 },
    { product: "White Go Runners", size: "40", stock: 2 },
    { product: "White Go Runners", size: "41", stock: 2 },
    { product: "White Go Runners", size: "42", stock: 2 },
    { product: "White Go Runners", size: "43", stock: 2 },
    { product: "White Go Runners", size: "44", stock: 2 },
    
    // Beige Go Runners
    { product: "BurgundyRunners", size: "35", stock: 1 },
    { product: "BurgundyRunners", size: "36", stock: 2 },
    { product: "BurgundyRunners", size: "37", stock: 2 },
    { product: "BurgundyRunners", size: "38", stock: 2 },
    { product: "BurgundyRunners", size: "39", stock: 2 },
    { product: "BurgundyRunners", size: "40", stock: 2 },
    { product: "BurgundyRunners", size: "41", stock: 2 },
    { product: "BurgundyRunners", size: "42", stock: 2 },
    { product: "BurgundyRunners", size: "43", stock: 2 },
    { product: "BurgundyRunners", size: "44", stock: 2},
    

    { product: "White/Black PΛREΛGON RUNNERS", size: "35", stock: 2 },
    { product: "White/Black PΛREΛGON RUNNERS", size: "36", stock: 2 },
    { product: "White/Black PΛREΛGON RUNNERS", size: "37", stock: 2 },
    { product: "White/Black PΛREΛGON RUNNERS", size: "38", stock: 2 },
    { product: "White/Black PΛREΛGON RUNNERS", size: "39", stock: 2 },
    { product: "White/Black PΛREΛGON RUNNERS", size: "40", stock: 2 },
    { product: "White/Black PΛREΛGON RUNNERS", size: "41", stock: 2 },
    { product: "White/Black PΛREΛGON RUNNERS", size: "42", stock: 2 },
    { product: "White/Black PΛREΛGON RUNNERS", size: "43", stock: 2 },
    { product: "White/Black PΛREΛGON RUNNERS", size: "44", stock: 2 },

    { product: "Black Runners", size: "35", stock: 2 },
    { product: "Black Runners", size: "36", stock: 2 },
    { product: "Black Runners", size: "37", stock: 2 },
    { product: "Black Runners", size: "38", stock: 2 },
    { product: "Black Runners", size: "39", stock: 2 },
    { product: "Black Runners", size: "40", stock: 2 },
    { product: "Black Runners", size: "41", stock: 2 },
    { product: "Black Runners", size: "42", stock: 2 },
    { product: "Black Runners", size: "43", stock: 2 },
    { product: "Black Runners", size: "44", stock: 2 },
    
    
    // Noir Off White
    { product: "Noir Off White", size: "43", stock: 3 },
    { product: "Noir Off White", size: "42", stock: 2 },
    { product: "Noir Off White", size: "41", stock: 2 },
    { product: "Noir Off White", size: "40", stock: 1 },

        // Yellow Runners
    { product: "Yellow Runners", size: "38", stock: 0 },
    { product: "Yellow Runners", size: "44", stock: 0 },
    { product: "Yellow Runners", size: "43", stock: 0 },
    { product: "Yellow Runners", size: "42", stock: 0 },
    { product: "Yellow Runners", size: "41", stock: 0 },
    { product: "Yellow Runners", size: "40", stock: 0 },
    { product: "Yellow Runners", size: "39", stock: 0 },
    { product: "Yellow Runners", size: "36", stock: 0 },
  ], []);


  const fetchOrders = useCallback(async () => {
    try {
      const res = await fetch("https://shoe-website-p3no.onrender.com/orders");
      const data = await res.json();
      setOrders(data.reverse());
    } catch (error) {
      console.error("Error fetching orders:", error);
      setOrders([]);
    }
  }, []);

  const fetchInventory = useCallback(async () => {
    try {
      // Replace with your actual API call
      const res = await fetch("https://shoe-website-p3no.onrender.com/inventory");
      const data = await res.json();
      const inventoryData = data.length > 0 ? data : initialInventoryData;
      
      setInventory(inventoryData);
      setOriginalInventory(inventoryData);
    } catch (error) {
      console.error("Error fetching inventory:", error);
      setInventory(initialInventoryData);
      setOriginalInventory(initialInventoryData);
    }
  }, [initialInventoryData]);

  useEffect(() => {
    if (authenticated) {
      fetchOrders();
      fetchInventory();
    }
  }, [authenticated, fetchOrders, fetchInventory]);

  const handleSaveInventory = async () => {
    try {
      const res = await fetch("https://shoe-website-p3no.onrender.com/inventory", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(inventory)
      });
      
      if (res.ok) {
        alert("Inventory updated!");
        setEditingInventory(false);
        setOriginalInventory(inventory);
      } else {
        throw new Error("Failed to save inventory");
      }
    } catch (error) {
      console.error("Error saving inventory:", error);
      alert("Error saving inventory. Please try again.");
    }
  };

  const handleCancelEdit = () => {
    setInventory(originalInventory);
    setEditingInventory(false);
    setShowAddForm(false);
    setNewItem({ product: "", size: "", stock: 0 });
  };

  const handleAddNewItem = () => {
    if (newItem.product && newItem.size && newItem.stock >= 0) {
      const updatedInventory = [...inventory, { ...newItem }];
      setInventory(updatedInventory);
      setNewItem({ product: "", size: "", stock: 0 });
      setShowAddForm(false);
    } else {
      alert("Please fill in all fields");
    }
  };

  const handleDeleteItem = (index) => {
    if (window.confirm("Are you sure you want to delete this item?")) {
      const updatedInventory = inventory.filter((_, i) => i !== index);
      setInventory(updatedInventory);
    }
  };

  const handleUpdateOrder = async (order, shippedStatus) => {
    try {
      await fetch("https://shoe-website-p3no.onrender.com/update-order", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          timestamp: order.timestamp,
          shipped: shippedStatus,
        })
      });
      fetchOrders();
    } catch (error) {
      console.error("Error updating order:", error);
      alert("Error updating order status");
    }
  };

  const handleLogin = () => {
    if (password === "$Jumpjump7676") {
      setAuthenticated(true);
    } else {
      alert("Incorrect password");
    }
  };

  if (!authenticated) {
    return (
      <div className="max-w-md mx-auto p-10">
        <h1 className="text-2xl mb-4 font-bold">Admin Login</h1>
        <input
          type="password"
          placeholder="Enter admin password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          className="w-full border p-2 mb-4 rounded"
        />
        <button
          onClick={handleLogin}
          className="w-full bg-black text-white py-2 rounded"
        >
          Login
        </button>
      </div>
    );
  }

  return (
    <div className="max-w-7xl mx-auto px-6 py-10 font-sans">
      <h1 className="text-3xl font-bold mb-6">Admin Dashboard</h1>

      {/* Orders */}
      <h2 className="text-2xl font-semibold mb-4">Orders</h2>
      <input
        type="text"
        placeholder="Search by email or product..."
        value={search}
        onChange={(e) => setSearch(e.target.value)}
        className="w-full border p-2 mb-4 rounded"
      />
      <table className="w-full border text-sm mb-10">
        <thead>
          <tr className="bg-gray-100">
            <th className="border p-2">Email</th>
            <th className="border p-2">Name</th>
            <th className="border p-2">Address</th>
            <th className="border p-2">Products</th>
            <th className="border p-2">Total</th>
            <th className="border p-2">Status</th>
            <th className="border p-2">Date</th>
            <th className="border p-2">Action</th>
          </tr>
        </thead>
        <tbody>
          {orders
            .filter(
              (o) =>
                o.email?.toLowerCase().includes(search.toLowerCase()) ||
                o.cart?.some((item) =>
                  item.name.toLowerCase().includes(search.toLowerCase())
                )
            )
            .map((order, i) => (
              <tr key={i}>
                <td className="border p-2">{order.email}</td>
                <td className="border p-2">{order.name}</td>
                <td className="border p-2 text-xs">
                  {order.address?.line1}, {order.address?.city},{" "}
                  {order.address?.state} {order.address?.postal_code}
                </td>
                <td className="border p-2 text-xs">
                  {order.cart?.map((item, idx) => (
                    <div key={idx}>
                      {item.name} ({item.selectedSize}) x{item.quantity || 1}
                    </div>
                  ))}
                </td>
                <td className="border p-2">${order.total}</td>
                <td className="border p-2">
                  {order.shipped ? (
                    <span className="bg-green-200 text-green-800 px-2 py-1 rounded text-xs">
                      Shipped
                    </span>
                  ) : (
                    <span className="bg-yellow-200 text-yellow-800 px-2 py-1 rounded text-xs">
                      Processing
                    </span>
                  )}
                </td>
                <td className="border p-2 text-xs">
                  {new Date(order.timestamp).toLocaleString()}
                </td>
                <td className="border p-2">
                  <button
                    onClick={() => handleUpdateOrder(order, !order.shipped)}
                    className="bg-blue-500 text-white px-2 py-1 rounded text-xs"
                  >
                    Mark {order.shipped ? "Processing" : "Shipped"}
                  </button>
                </td>
              </tr>
            ))}
        </tbody>
      </table>

      {/* Inventory */}
      <div className="flex justify-between items-center mb-4">
        <h2 className="text-2xl font-semibold">Inventory Management</h2>
        <div className="text-sm text-gray-600">
          Total Items: {inventory.length} | Low Stock: {inventory.filter(item => item.stock < 5).length}
        </div>
      </div>

      <table className="w-full border text-sm mb-6">
        <thead>
          <tr className="bg-gray-100">
            <th className="border p-2">Product Name</th>
            <th className="border p-2">Size</th>
            <th className="border p-2">Stock</th>
            {editingInventory && <th className="border p-2">Actions</th>}
          </tr>
        </thead>
        <tbody>
          {inventory.map((item, i) => (
            <tr key={i} className={item.stock < 5 ? "bg-red-50" : ""}>
              <td className="border p-2">{item.product}</td>
              <td className="border p-2">{item.size}</td>
              <td className="border p-2">
                {editingInventory ? (
                  <input
                    type="number"
                    min="0"
                    value={item.stock}
                    onChange={(e) => {
                      const newInventory = [...inventory];
                      newInventory[i].stock = parseInt(e.target.value, 10) || 0;
                      setInventory(newInventory);
                    }}
                    className={`w-20 border p-1 rounded ${
                      item.stock < 5 ? "bg-red-100 border-red-300" : ""
                    }`}
                  />
                ) : (
                  <span className={item.stock < 5 ? "text-red-600 font-semibold" : ""}>
                    {item.stock}
                    {item.stock < 5 && " ⚠️"}
                  </span>
                )}
              </td>
              {editingInventory && (
                <td className="border p-2">
                  <button
                    onClick={() => handleDeleteItem(i)}
                    className="bg-red-500 text-white px-2 py-1 rounded text-xs hover:bg-red-600"
                  >
                    Delete
                  </button>
                </td>
              )}
            </tr>
          ))}
          
          {/* Add new item row */}
          {editingInventory && showAddForm && (
            <tr className="bg-blue-50">
              <td className="border p-2">
                <input
                  type="text"
                  placeholder="Product name"
                  value={newItem.product}
                  onChange={(e) => setNewItem({...newItem, product: e.target.value})}
                  className="w-full border p-1 rounded"
                />
              </td>
              <td className="border p-2">
                <input
                  type="text"
                  placeholder="Size"
                  value={newItem.size}
                  onChange={(e) => setNewItem({...newItem, size: e.target.value})}
                  className="w-full border p-1 rounded"
                />
              </td>
              <td className="border p-2">
                <input
                  type="number"
                  min="0"
                  placeholder="Stock"
                  value={newItem.stock}
                  onChange={(e) => setNewItem({...newItem, stock: parseInt(e.target.value, 10) || 0})}
                  className="w-20 border p-1 rounded"
                />
              </td>
              <td className="border p-2">
                <div className="flex gap-1">
                  <button
                    onClick={handleAddNewItem}
                    className="bg-green-500 text-white px-2 py-1 rounded text-xs hover:bg-green-600"
                  >
                    Add
                  </button>
                  <button
                    onClick={() => {
                      setShowAddForm(false);
                      setNewItem({ product: "", size: "", stock: 0 });
                    }}
                    className="bg-gray-500 text-white px-2 py-1 rounded text-xs hover:bg-gray-600"
                  >
                    Cancel
                  </button>
                </div>
              </td>
            </tr>
          )}
        </tbody>
      </table>

      {editingInventory ? (
        <div className="flex gap-4 mb-6">
          <button
            onClick={handleSaveInventory}
            className="bg-black text-white px-4 py-2 rounded hover:bg-gray-800"
          >
            Save Inventory
          </button>
          <button
            onClick={handleCancelEdit}
            className="bg-gray-500 text-white px-4 py-2 rounded hover:bg-gray-600"
          >
            Cancel
          </button>
          {!showAddForm && (
            <button
              onClick={() => setShowAddForm(true)}
              className="bg-green-600 text-white px-4 py-2 rounded hover:bg-green-700"
            >
              + Add New Item
            </button>
          )}
        </div>
      ) : (
        <button
          onClick={() => setEditingInventory(true)}
          className="bg-gray-700 text-white px-4 py-2 rounded mb-6 hover:bg-gray-800"
        >
          Edit Inventory
        </button>
      )}
    </div>
  );
};

export default AdminDashboard;